import { render, staticRenderFns } from "./SystemInternManagement.vue?vue&type=template&id=ca53b64c"
import script from "./SystemInternManagement.vue?vue&type=script&lang=js"
export * from "./SystemInternManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports